import { jsx, Fragment } from "react/jsx-runtime";
import { forwardRef, useState, useEffect } from "react";
import SwipeableDrawerSystem from "@mui/material/SwipeableDrawer";
const SwipeableDrawer = forwardRef(
  function SwipeableDrawer2(inProps, ref) {
    const { eventId, open, autoDestroy, ModalProps, ...props } = inProps;
    const [render, setRender] = useState(open);
    useEffect(() => {
      if (open) {
        setRender(true);
      }
    }, [open]);
    function handleExited(node) {
      setRender(false);
      if (ModalProps && ModalProps.BackdropProps && ModalProps.BackdropProps.onExited) {
        ModalProps.BackdropProps.onExited(node);
      }
    }
    if (autoDestroy) {
      return /* @__PURE__ */ jsx(Fragment, { children: render && /* @__PURE__ */ jsx(
        SwipeableDrawerSystem,
        {
          ...props,
          open,
          ref,
          "data-eventid": eventId,
          ModalProps: {
            ...ModalProps,
            BackdropProps: {
              ...ModalProps && ModalProps.BackdropProps,
              onExited: handleExited
            }
          }
        }
      ) });
    } else {
      return /* @__PURE__ */ jsx(
        SwipeableDrawerSystem,
        {
          ...props,
          open,
          ref,
          "data-eventid": eventId,
          ModalProps
        }
      );
    }
  }
);
export {
  SwipeableDrawer
};
//# sourceMappingURL=swipeable-drawer.component.js.map
